import { useContext } from 'react';
import { filter, map, isEmpty, each } from 'underscore';
import { ConversionHelpContext } from '@bingads-webui-campaign-react/conversion-help';

export const MAX_EMAIL_ADDRESSES_COUNT = 10;

export const senders = {
  Container: 'Unified Smart',
  DMC: 'Digital Marketing Center',
  UET: 'Microsoft Advertising',
};

export function useHelpIds() {
  const helpIds = useContext(ConversionHelpContext);

  return helpIds.emailTag;
}

// TODO: Should this be updated for UP
export const supportTeamLinks = {
  Container: 'https://help.digitalmarketing.microsoft.com/#apex/27/en/30006/',
  DMC: 'https://help.digitalmarketing.microsoft.com/#apex/27/en/30006/',
  UET: 'https://help.ads.microsoft.com/',
};

const isValidEmailAddress = (address) => {
  const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(address).toLowerCase());
};

export const genEmailAddresses = (emailAddresses) => {
  const trimmedAddress = map(emailAddresses, address => address.trim());
  const validEmailAddresses = filter(trimmedAddress, address => isValidEmailAddress(address));

  return validEmailAddresses.join(';');
};

export const splitEmailAddresses = (emailAddresses) => {
  const validEmailAddresses = [];
  const invalidEmailAddresses = [];
  const trimmedAddress = map(emailAddresses, address => address.trim());
  each(trimmedAddress, (address) => {
    if (isEmpty(address.trim())) {
      return;
    }
    if (isValidEmailAddress(address)) {
      validEmailAddresses.push(address);
    } else {
      invalidEmailAddresses.push(address);
    }
  });
  return [validEmailAddresses, invalidEmailAddresses];
};

export const canSendEmail = (validEmailAddresses, invalidEmailAddresses) =>
  validEmailAddresses.length > 0 &&
  validEmailAddresses.length <= MAX_EMAIL_ADDRESSES_COUNT &&
  invalidEmailAddresses.length === 0;
